export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },

  computed: {
    isFav () {
      return this.$store.getters['data/isEntityFav'](this.content.id)
    }
  },

  methods: {
    onToggleFav () {
      if (this.isFav) {
        this.removeFav()
      }
      else {
        this.addFav()
      }
    },
    addFav () {
      this.$ga.send('Content', 'Favourite', this.content.title)
      this.$store.dispatch('user/addFav', {
        id: this.content.id,
        url: this.url === '' ? this.content.url : this.url
      })
    },
    removeFav () {
      this.$store.dispatch('user/removeFav', this.content.id)
    }
  }
}